








































import {latLng, LatLng} from "leaflet";
import {LMap, LTileLayer, LMarker, LPopup, LTooltip} from "vue2-leaflet";
import 'leaflet/dist/leaflet.css';
import {Component, Vue} from 'vue-property-decorator'
import GreenButton from "@/views/GreenButton.vue"
import ModalWindow from "@/views/ModalWindow.vue"

@Component({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    GreenButton,
    ModalWindow,
  }
})
export default class AddHelperForm extends Vue {
  private zoom = 2
  private center = latLng(50, 0)
  private url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  private attribution = '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
  private pin = this.center
  private isPinMoved = false
  private name = ''
  private phone = ''
  private isCodeSent = false
  private isCodeConfirmed = false
  private isConfirmationSent = false
  private errorMessage = ''
  private userCode = ''
  private userId = 0

  private onPinChange(event: LatLng) {
    this.pin = event
    this.isPinMoved = true
  }

  private get isNameFilled() {
    return this.name !== ''
  }

  private get isPhoneFilled() {
    return this.phone !== ''
  }

  private get formIsReady() {
    return this.isPinMoved && this.isNameFilled && this.isPhoneFilled
  }

  private get isError() {
    return this.errorMessage !== '';
  }

  private setError(errorCode: string) {
    this.errorMessage = errorCode;
  }

  private clearError() {
    this.errorMessage = ''
  }

  private sendCode() {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify({
        name: this.name,
        phone: this.phone,
        lat: this.pin.lat.toString(),
        lng: this.pin.lng.toString()
      })
    }
    fetch(process.env.VUE_APP_API_HOST + '/helper-map', requestOptions)
        .then(response => {
              if (!response.ok) {
                response.json()
                    .then(text => {
                          throw Error(text)
                        }
                    )
                    .catch((error) => this.setError(error.message))
              } else {
                response.json()
                    .then(data => {
                          this.isCodeSent = true
                          this.userId = data
                        }
                    )
                    .catch((error) => this.setError(error.message))
              }
            }
        )
        .catch(() => this.setError('DefaultErrorMessage'))
  }

  private confirmCode() {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify({
        code: this.userCode
      })
    }
    fetch(process.env.VUE_APP_API_HOST + '/helper-map/' + this.userId.toString() + '/add-confirm', requestOptions)
        .then(response => {
              if (!response.ok) {
                response.json()
                    .then(text => {
                        throw Error(text)
                      }
                    )
                    .catch((error) => this.setError(error.message))
              } else {
                this.isConfirmationSent = true
                this.isCodeConfirmed = true
              }
            }
        )
        .catch((error) => this.setError(error.message))
  }
}
